module.exports = __webpack_public_path__ + "img/notify-icon-error.4cf92a53.svg";